import React from 'react';
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import WebsiteRoutes from "./route-guards/website-routes";
import "./App.less";

// Website-specific App component
function WebsiteApp() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#3441C1",
        },
      }}
    >
      <div className="app-container">
        <div className="app-content" id="main-content" role="main">
          <BrowserRouter>
            <WebsiteRoutes />
          </BrowserRouter>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default WebsiteApp;
